import { render, staticRenderFns } from "./OnlineOffline.vue?vue&type=template&id=80c7071c&scoped=true&"
import script from "./OnlineOffline.vue?vue&type=script&lang=js&"
export * from "./OnlineOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7071c",
  null
  
)

export default component.exports